// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__11qQY","tab":"Tabs_tab__1Pf3w","tabActive":"Tabs_tabActive__1N-z6"};